document.addEventListener('DOMContentLoaded', function() {
  var upload = document.querySelector('[data-logo-upload]');
  if (!upload) return;
  
  upload.style.transition = 'opacity 0.3s ease';
  upload.style.display = 'none';
  
  function checkLogo() {
    var variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;
    
    var variantScript = variantPicker.querySelector('script[data-variant]');
    if (!variantScript) return;
    
    try {
      var variant = JSON.parse(variantScript.textContent);
      if (!variant) return;
      
      var hasLogo = false;
      
      var logoOption = null;
      document.querySelectorAll('.variant-picker__option').forEach(function(opt) {
        var legend = opt.querySelector('legend');
        if (legend && legend.textContent.trim().toLowerCase().includes('logo')) logoOption = opt;
      });
      
      if (logoOption) {
        var dropdownBtn = logoOption.querySelector('button.select');
        if (dropdownBtn) {
          var radios = logoOption.querySelectorAll('input[type=radio]');
          radios.forEach(function(r, index) {
            if (r.checked && index === 1) {
              hasLogo = true;
            }
          });
        } else {
          var radios = logoOption.querySelectorAll('input[type=radio]');
          radios.forEach(function(r, index) {
            if (r.checked && index === 1) {
              hasLogo = true;
            }
          });
        }
      }
      
      if (hasLogo) {
        upload.style.display = 'block';
        upload.style.opacity = '1';
      } else {
        upload.style.display = 'none';
      }
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
  }
  
  checkLogo();
  
  document.addEventListener('variant:change', function(event) {
    checkLogo();
  });
}); 